// src/utils/axios.js 或 src/plugins/axios.js
import axios from 'axios'

// 创建 axios 实例
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    return response.data
  },
  error => {
    // 对响应错误做点什么
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 处理未授权
          console.log('未授权，请重新登录')
          // this.$router.push('/login') // 注意：这里不能直接使用 this
          break
        case 403:
          console.log('禁止访问')
          break
        case 404:
          console.log('请求的资源不存在')
          break
        case 500:
          console.log('服务器内部错误')
          break
      }
    }
    return Promise.reject(error)
  }
)

export default instance